
define(
	'Code25.Address'
	, [
		"underscore", "jQuery", "Profile.Model", 'c25_order_wizard_address_module.tpl', 'c25_address_edit_fields.tpl'
	]
	, function (
		_, jQuery, ProfileModel, c25_order_wizard_address_module_tpl, c25_address_edit_fields_tpl
	) {
		'use strict';

		return {
			mount: function (container) {

				var order_wizard_address_row_tpl = require("order_wizard_address_row.tpl");
				var order_wizard_address_cell_tpl = require("order_wizard_address_cell.tpl");
				var AddressDetailsView = require("Address.Details.View");
				var BackboneCollectionView = require("Backbone.CollectionView");
				if (AddressDetailsView.AddressDetailsView) {
					AddressDetailsView = AddressDetailsView.AddressDetailsView;
				}

				var OrderWizardModuleAddress = require("OrderWizard.Module.Address");

				var paymentinstrument_creditcard_edit_tpl = require('paymentinstrument_creditcard_edit.tpl');

				function updateFilter(e) {

					var keyword = e.target.value;

					this.keyword = keyword;
					var $infos = this.$el.find(".address-details-info");
					var $cell;
					var show = [], count = 0;
					$infos.each(function (e) {
						var $this = $(this);
						$cell = $this.closest(".order-wizard-address-row");
						if (allowAddress($this.text(), keyword)) {
							show.push({ visible: true, cell: $cell });
							count++;
						} else {
							show.push({ visible: false, cell: $cell });
						}
					})
					var pages = Math.ceil(count / 6), page = this.page;
					if (page >= pages) {
						page = pages - 1;
					}
					var index = 0;
					for (var i = 0; i < show.length; i++) {
						if (show[i].visible) {
							if (Math.floor(index / 6) == page) {
								show[i].cell.show();
							} else {
								show[i].cell.hide();
							}
							index++;
						} else {
							show[i].cell.hide();
						}
					}
					var p = 0;

					this.$el.find("a[data-action='show-page']").each(function () {
						if (p < pages) {
							$(this).show();
						} else {
							$(this).hide();
						}
						p++;
					});
					var $addresspages = this.$el.find(".address-pages");
					if (pages == 0) {
						$addresspages.hide();
					} else {
						$addresspages.show();
					}
					var $addressempty = this.$el.find(".address-empty");
					if (count == 0) {
						$addressempty.show();
					} else {
						$addressempty.hide();
					}

				}

				function allowAddress(text, keyword) {
					if (keyword && text) {
						text = text.toLowerCase();
						var keywords = keyword.toLowerCase().split(" ");
						var allowAddress;

						allowAddress = true;
						for (var k = 0; k < keywords.length; k++) {
							if (text.indexOf(keywords[k]) == -1) {
								allowAddress = false;
								break;
							}
						}
						return allowAddress;

					}
					return true;
				}



				OrderWizardModuleAddress.prototype.childViews['Address.List'] = function () {
					return new BackboneCollectionView({
						collection: this.getAddressesToShow(),
						viewsPerRow: 1,
						rowTemplate: order_wizard_address_row_tpl,
						cellTemplate: order_wizard_address_cell_tpl,
						childView: AddressDetailsView,
						childViewOptions: this.getAddressListOptions()
					});
				}

				OrderWizardModuleAddress.prototype.events['change input[type="text"]'] = 'updateFilter';
				OrderWizardModuleAddress.prototype.events['keyup input[type="text"]'] = 'updateFilter';
				OrderWizardModuleAddress.prototype.events['click a[data-action="show-page"]'] = 'showPage';
				OrderWizardModuleAddress.prototype.updateFilter = updateFilter;

				var _addresses;

				_.extend(OrderWizardModuleAddress.prototype, {
					page: 0,
					template: c25_order_wizard_address_module_tpl,
					initialize: _.wrap(OrderWizardModuleAddress.prototype.initialize, function (initialize) {

						_addresses = null;
						initialize.apply(this, _.rest(arguments));

						this.isSameAsEnabled = false;
						this.isSame = false;
						this.disableSameAsCheckBox = true;


					}),
					showPage: function (e) {
						var $a = $(e.target);
						var id = $a.attr('data-id');
						this.page = id;
						$a.parent().find("a").removeClass("active");
						$a.addClass("active");
						this.updateFilter({ target: { value: this.keyword } });
					},

					getAddressesToShow: function () {

						var addresses_to_show;

						if (this.addresses && !!this.addresses.length) {
							addresses_to_show = paymentinstrument_creditcard_edit_tpl
								? this.addresses.getCollectionForRendering()
								: this.addresses;
						}

						var addresses = addresses_to_show ? addresses_to_show.models : [];
						
						if(addresses.length>0&&addresses[addresses.length-1].id=="-1"){
							addresses.pop();
						}

						if (!_addresses) {
							var selectedShippingAddressId = this.model.get('shipaddress');

							addresses.sort(function (A, B) {
								if (B.get("internalid") == selectedShippingAddressId) {
									return 1;
								}
								else if (A.get("internalid") == selectedShippingAddressId) {
									return -1;
								}
								return (A.get("fullname")||"").localeCompare(B.get("fullname"));
							});
							_addresses = addresses;

						} else {
							return _addresses;
						}


						return _addresses;
					},
					evaluateSameAs: function () {

						this.sameAs = false;

						this.model.set('sameAs', this.sameAs);
					},
					eventHandlersOn: function () {

						this.eventHandlersOff();
var self=this;
						this.addresses
							// Adds events to the collection
							.on(
								'add',
								function (added_address) {
									this.address = added_address;
									this.addressId = added_address.get('internalid');

									this.model.set('shipaddress', this.addressId);
									_addresses = null;
									self.render(true);
									self.updateFilter({ target: { value: this.keyword } });
								},
								this
							)
							.on(
								'reset sync remove change destroy',
								function () {
									_addresses=null;
									self.render(true);
									self.updateFilter({ target: { value: this.keyword } });
								},
								self
							);

						_.isFunction(this.onEventHandlersOn) && this.onEventHandlersOn();
					},

					selectAddress: function (e) {
						jQuery('.wizard-content .alert-error').hide();

						this.model.set('sameAs', false, { silent: true });

						this.setAddress(
							jQuery(e.target)
								.data('id')
								.toString()
						);

						this.render();

						this.trigger('ready', true);
						this.updateFilter({ target: { value: this.keyword } });
					},
					getContext: function () {
						

						var selectedShippingAddressId = this.model.get('shipaddress');
						var selectedBillingAddressId = this.model.get('billaddress');
						var addresses = this.getAddressCollection();
						
						var shipModel, billModel
						var amodel;
						for (var i = 0; i < addresses.models.length; i++) {
							amodel = addresses.models[i];

							if (amodel.get("internalid") == selectedShippingAddressId) {
								shipModel = amodel;

							}
							if (amodel.get("internalid") == selectedBillingAddressId) {
								billModel = amodel;
							}

						}
						var addresses = this.getAddressesToShow();
						var count = (addresses || [0]).length - 1;

						var pages = Math.ceil(count / 6);
						if (this.page >= pages) {
							this.page = 0;
						}

						var pageLinks = [];
						if (this.manage == "shipaddress" && pages > 1) {
							for (var i = 0; i < pages; i++) {
								pageLinks.push({ id: i, name: (i + 1) });
							}
						}

						return {
							shipModel: shipModel,
							billModel: billModel,
							fixAddress: this.manage == "billaddress" && billModel,
							pageLinks: pageLinks,
							showPageLinks: pageLinks.length > 0,
							showToolbar:this.getAddressCollection().length>0,
							page: this.page,
							// @property {Boolean} showTitle
							showTitle: !!(!this.options.hide_title && this.getTitle()),
							// @property {String} title
							title: this.getTitle(),
							// @property {Boolean} isSameAsEnabled
							isSameAsEnabled: false,
							// @property {Boolean} isSameAsCheckBoxDisable
							isSameAsCheckBoxDisable: !!this.disableSameAsCheckBox,
							// @property {Boolean} isSameAsSelected
							isSameAsSelected: false,
							// @property {String} sameAsMessage
							sameAsMessage: this.sameAsMessage,
							// @property {Boolean} showSingleAddressDetails
							showSingleAddressDetails: !!(
								this.address &&
								this.address.get('internalid') &&
								(
									(this.addressId && !this.address.isNew()) ||
									(addresses.length && this.isGuest))
							),
							// @property {Boolean} showAddressList
							showAddressList: !!(addresses.length > 1),
							// @property {String} changeLinkText
							changeLinkText: this.getChangeLinkText(),
							// @property {String} selectedAddressId
							selectedAddressId: (this.address && this.address.get('internalid')) || '',
							// @property {Boolean} showManageValue
							showManageValue: !!this.manage,
							// @property {Boolean} manageValue
							manageValue: this.manage,
							// @property {Boolean} showSaveButton
							showSaveButton: this.showSaveButton
						};
					}

				});

				var AddressEditFieldsView = require("Address.Edit.Fields.View");

				if (AddressEditFieldsView.AddressEditFieldsView) {
					AddressEditFieldsView = AddressEditFieldsView.AddressEditFieldsView;
				}

				AddressEditFieldsView.prototype.template = c25_address_edit_fields_tpl;

				var AddressEditView = require("Address.Edit.View");

				AddressEditView.prototype.events['submit form'] = 'saveForm2';

				AddressEditView.prototype.saveForm2 = function saveForm2(e) {
					var label = this.$el.find("input[name='zip']").val() || this.$el.find("input[name='addr2']").val();
					var addr1 = this.$el.find("input[name='addr1']").val();
					if (addr1) {
						label += " (" + addr1 + ")";
					}
					this.model.set("label", label, { silent: true });
					return this.saveForm(e);
				}

				var AddressDetailsView=require("Address.Details.View");
				if(AddressDetailsView.AddressDetailsView){
					AddressDetailsView=AddressDetailsView.AddressDetailsView;
				}

				_.extend(AddressDetailsView.prototype, {

                    getContext: _.wrap(AddressDetailsView.prototype.getContext, function (getContext) {

                        var res = getContext.apply(this, _.rest(arguments));
						 
                        res.title=this.model.get('fullname')||"";
                        return res;

                    })
                });

			}
		};

	});
